import React from "react";
import ReactDOM from "react-dom";
import "./css/ui.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";

/*
 *
 * Description:
 *   Main component of app
 * Authors:
 *   Andres Alvarez Duran, ID: 117520958
 *   Joaquin Barrientos Monge, ID: 117440348
 *   Oscar Ortiz Chavarria, ID: 208260347
 *   David Zarate Marin, ID: 116770797
 *   Group: 01
 *   Schedule: 10am
 *
 */
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
